import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { orderAPI } from '../../services/api';

// Async thunks
export const createOrder = createAsyncThunk(
  'orders/createOrder',
  async (orderData, { rejectWithValue }) => {

    try {
      const response = await orderAPI.create(orderData);
      return response.data;
    } catch (error) {
      console.error('Order creation error:', error.response?.data);
      return rejectWithValue(error.response?.data?.message || error.response?.data || 'Failed to create order');
    }
  }
);

export const fetchUserOrders = createAsyncThunk(
  'orders/fetchUserOrders',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await orderAPI.getUserOrders(userId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch orders');
    }
  }
);

const initialState = {
  orders: [],
  currentOrder: null,
  loading: false,
  error: null,
  orderSuccess: false,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearOrderSuccess: (state) => {
      state.orderSuccess = false;
    },
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create order
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.orderSuccess = false;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.currentOrder = action.payload;
        state.orderSuccess = true;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        // Normalize error payload to a string so UI won't attempt to render an object
        if (typeof action.payload === 'string') {
          state.error = action.payload;
        } else if (action.payload && typeof action.payload === 'object') {
          state.error = action.payload.message || JSON.stringify(action.payload);
        } else {
          state.error = 'Failed to create order';
        }
        state.orderSuccess = false;
      })
      // Fetch user orders
      .addCase(fetchUserOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchUserOrders.rejected, (state, action) => {
        state.loading = false;
        if (typeof action.payload === 'string') {
          state.error = action.payload;
        } else if (action.payload && typeof action.payload === 'object') {
          state.error = action.payload.message || JSON.stringify(action.payload);
        } else {
          state.error = 'Failed to fetch orders';
        }
      });
  },
});

export const { clearError, clearOrderSuccess, setCurrentOrder } = ordersSlice.actions;
export default ordersSlice.reducer; 